import PropTypes from 'prop-types';
import React from 'react';
import compose from '../../../hoc/compose';
import displayNames from '../../displayNames';
var RoundedIllustrationContainer = function RoundedIllustrationContainer(props) {
  return /*#__PURE__*/React.createElement("div", {
    className: props.getClassName('rounded-illustration-container'),
    "data-hook": props.dataHook
  }, /*#__PURE__*/React.createElement("div", {
    className: "rounded-illustration-icon-content"
  }, props.children));
};
RoundedIllustrationContainer.propTypes = {
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  /** The content of the `RoundedIllustrationContainer` */
  children: PropTypes.node
};
RoundedIllustrationContainer.DisplayName = displayNames.ROUNDED_ILLUSTRATION_CONTAINER;
export default compose(RoundedIllustrationContainer);